import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Role = 'admin' | 'sre' | 'manager' | 'director';

export interface User {
  sub: string; // email
  role: Role;
  exp?: number; // unix ts
}

interface AuthState {
  jwt: string | null;
  user: User | null;
  isAuthenticated: boolean;
  setAuth: (jwt: string, user: User) => void;
  logout: () => void;
}

function decodeJwtPayload(token: string): User | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]!.replace(/-/g, '+').replace(/_/g, '/')));
    return {
      sub: payload.sub,
      role: payload.role || 'manager',
      exp: payload.exp,
    };
  } catch {
    return null;
  }
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      jwt: null,
      user: null,
      isAuthenticated: false,

      setAuth: (jwt, user) => {
        set({ jwt, user, isAuthenticated: true });
      },

      logout: () => {
        set({ jwt: null, user: null, isAuthenticated: false });
        // Limpar storage de todas as apps filhas
        localStorage.removeItem('surf_jwt');
      },
    }),
    {
      name: 'surf-monitor-auth',
      partialize: (state) => ({
        jwt: state.jwt,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
      // Validar exp ao reidratar
      onRehydrateStorage: () => (state) => {
        if (state?.jwt && state?.user?.exp) {
          const now = Math.floor(Date.now() / 1000);
          if (state.user.exp < now) {
            state.logout();
          }
        }
      },
    },
  ),
);

export { decodeJwtPayload };
